import React from "react";
import Head from "next/head";

const DefaultHead = () => {
  const title = "장종인 — 포트폴리오";
  const desc = "";
  const url = "https://jangjong.in";

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Jang Jong-in" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="ko_KR" />
    </Head>
  );
};

export default DefaultHead;
